import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Projects from '../views/Project/Manage.vue'
import Research from '../views/Project/Research.vue'
import Analyze from '../views/Project/Analyze.vue'
import Report from '../views/Project/Report.vue'
import Participants from '../views/Participants.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Chat from '@/views/Chat.vue'
import ResetPassword from '../views/ResetPassword.vue'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/', name: 'Dashboard', component: Dashboard, meta: { requiresAuth: true } },
    { path: '/projects', name: 'Projects', component: Projects, meta: { requiresAuth: true } },
    { path: '/projects/research', name: 'Research', component: Research, meta: { requiresAuth: true } },
    { path: '/projects/analyze', name: 'Analyze', component: Analyze, meta: { requiresAuth: true } },
    { path: '/projects/report', name: 'Report', component: Report, meta: { requiresAuth: true } },
    { path: '/participants', name: 'Participants', component: Participants, meta: { requiresAuth: true } },
    { path: '/login', name: 'Login', component: Login },
    { path: '/register', name: 'Register', component: Register },
    { path: '/chat', name: 'Chat', component: Chat, meta: { requiresAuth: true } },
    { path: '/reset-password', name: 'ResetPassword', component: ResetPassword },
    {
      path: '/projects/research/data-collection',
      name: 'DataCollection',
      component: () => import('@/views/Project/DataCollection.vue')
    },
    {
      path: '/projects/data-overview',
      name: 'DataOverview',
      component: () => import('@/views/Project/DataOverview.vue'),
      meta: { 
        requiresAuth: true,
        layout: 'ProjectLayout'
      }
    },
    // Redirect any unknown paths to the dashboard
    { path: '/:pathMatch(.*)*', redirect: '/' }
  ],
})

// Router guard for authentication
router.beforeEach((to, from, next) => {
  const auth = useAuthStore()
  const publicPages = ['Login', 'Register', 'ResetPassword']
  const authRequired = !publicPages.includes(to.name)
  
  if (authRequired && !(auth.accessToken || auth.refreshToken)) {
    next({ name: 'Login', query: { redirect: to.fullPath } })
  } else if (
    publicPages.includes(to.name) &&
    (auth.accessToken || auth.refreshToken)
  ) {
    next({ name: 'Dashboard' })
  } else {
    next()
  }
})

export default router
